import { Component, Input, inject } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MultiLangService } from '../../services/multi-lang.service';

@Component({
  selector: 'app-spinner-load',
  standalone: true,
  imports: [CommonModule, MatProgressBarModule, TranslateModule],
  templateUrl: './spinner-load.component.html',
  styleUrl: './spinner-load.component.scss',
})
export class SpinnerLoadComponent {
  currentMessage = '';
  private router = inject(Router);
  private translate = inject(TranslateService);
  private static knowledgeIndex = 0;
  private static lessonsIndex = 0;
  combinedHeaderText = '';
  languageCode = '';

  @Input() set key(_: number) {
    this.setMessage();
  }
  constructor(public multiLangService: MultiLangService) {
    this.languageCode = this.multiLangService.getStoredLanguage();
    this.updateHeaderText();
    this.translate.onLangChange.subscribe(() => {
      this.updateHeaderText();
    });
  }
  private setMessage(): void {
    const currentUrl = this.router.url;
    const isLessonsRoute =
      currentUrl.includes('/lessons-view/') ||
      currentUrl.includes('/lessons-learning/');

    const key = isLessonsRoute
      ? 'SPINNER.LESSONS_MESSAGES'
      : 'SPINNER.KNOWLEDGE_MESSAGES';

    this.translate.get(key).subscribe((messages: string[]) => {
      const indexProp = isLessonsRoute ? 'lessonsIndex' : 'knowledgeIndex';
      const currentIndex = SpinnerLoadComponent[indexProp]++;
      SpinnerLoadComponent[indexProp] %= messages.length;
      this.currentMessage = messages[currentIndex];
    });
  }
  private updateHeaderText() {
    this.translate.get('HOME.HEADER.TITLE').subscribe((title) => {
      this.translate.get('HOME.HEADER.NAME').subscribe((name) => {
        const currentLang = this.translate.currentLang;
        const nameFirstLangs = ['es', 'fr', 'pt'];
        if (nameFirstLangs.includes(currentLang)) {
          this.combinedHeaderText = `${name} ${title}`;
        } else {
          this.combinedHeaderText = `${title} ${name}`;
        }
      });
    });
  }
}
